import { render, staticRenderFns } from "./strategyView.vue?vue&type=template&id=6b398efc&scoped=true"
import script from "./strategyView.vue?vue&type=script&lang=js"
export * from "./strategyView.vue?vue&type=script&lang=js"
import style0 from "./strategyView.vue?vue&type=style&index=0&id=6b398efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b398efc",
  null
  
)

export default component.exports